__turbopack_context__.v({
  "dirhamIcon": "currency-module__yfLmNG__dirhamIcon",
  "dirhamIconGreen": "currency-module__yfLmNG__dirhamIconGreen",
  "dirhamIconWhite": "currency-module__yfLmNG__dirhamIconWhite",
});
